import {Model} from 'vue-mc';


/**
 * IntPromotedCarouselModel model
 */

export class WelcomePageModel extends Model {

    // Default attributes that define the "empty" state.
    defaults() {
        return {

        }
    }
}



// WEBPACK FOOTER //
// ./src/models/welcomePageModel.js